import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import GuideLayout from './GuideLayout';
import generatorPreview from '../../../img/guide-szarfa-generator.webp';

// Poradnik pod frazy wyszukiwane przez kwiaciarnie i zakłady: „drukowanie szarf pogrzebowych”,
// „program do drukowania szarf”, „drukarka do szarf pogrzebowych”, „jak zrobić szarfę pogrzebową”.

const STEPS = [
    {
        title: 'Ustal treść z rodziną',
        text: (
            <>
                Zwykle dwie szarfy: dla kogo jest wieniec i od kogo. Gotowe teksty znajdziesz w poradniku{' '}
                <Link to='/napisy-na-szarfy'>napisy na szarfy pogrzebowe</Link>.
            </>
        ),
    },
    {
        title: 'Dobierz wymiary szarfy',
        text: 'Długość szarfy i szerokość wstążki zależą od wieńca lub wiązanki. Ustaw je w centymetrach - tak, jak masz je na rolce.',
    },
    {
        title: 'Ułóż napis i dodatki',
        text: 'Wpisz tekst, dobierz wielkość liter, dodaj symbol - krzyż, różę, znicz - i wybierz obramowanie. Sprawdź pisownię imion.',
    },
    {
        title: 'Wydrukuj na szarfie',
        text: 'Najczęściej drukarką termotransferową do szarf z folią (np. złotą, srebrną lub czarną). Możesz też przekazać plik PDF drukarni.',
    },
    {
        title: 'Przymocuj do wieńca',
        text: 'Zostaw zapas wstążki na końcach do przypięcia i wykończenia. Napis powinien być czytelny po rozłożeniu szarfy.',
    },
];

const FEATURES = [
    { title: 'Gotowe napisy jednym kliknięciem', text: '„Ukochanej Mamie”, „Syn z rodziną”, „Wnuki” i inne - albo własny tekst. Za długi napis sam się zmniejszy, żeby zmieścić się na szarfie.' },
    { title: '10 symboli żałobnych', text: 'Krzyż, krzyż z promieniami, róża, lilia, znicz, gołąb, gałązka, kłosy, wieniec i serce - każdy możesz dodać kilka razy.' },
    { title: 'Własne grafiki', text: 'Wgraj obraz PNG lub JPG, np. logo zakładu, herb albo symbol, i ustaw go w dowolnym miejscu szarfy.' },
    { title: '14 wzorów obramowania', text: 'Linie, perełki, sznur, listki, meander, ornament i inne - w kolorze czarnym, złotym, srebrnym lub dowolnym.' },
    { title: 'Podgląd zawsze na widoku', text: 'Podgląd całej szarfy jest stale u góry ekranu. Elementy przesuwasz myszką lub palcem, a grafiki powiększasz narożnikiem.' },
    { title: 'PDF w skali 1:1', text: 'Plik ma dokładnie wymiary szarfy w centymetrach - gotowy do wydruku na drukarce do szarf.' },
];

const FOR_WHOM = [
    { title: 'Kwiaciarnie', text: 'Szybkie szarfy do wieńców i wiązanek - także przy dużej liczbie zamówień przed pogrzebem.' },
    { title: 'Zakłady pogrzebowe', text: 'Szarfy z tych samych danych co nekrolog, klepsydra i tabliczka - bez przepisywania.' },
    { title: 'Drukarnie i pracownie', text: 'Gotowe pliki PDF w wymiarze szarfy, które łatwo przyjąć od klienta i wydrukować.' },
];

const TIPS = [
    { title: 'Kontrast przede wszystkim', text: 'Złoty lub srebrny nadruk na ciemnej wstążce i czarny na jasnej są czytelne z daleka.' },
    { title: 'Czcionka szeryfowa, pogrubiona', text: 'Klasyczne, grube litery dobrze wyglądają na satynie i nie giną w fałdach wstążki.' },
    { title: 'Krótki tekst = większe litery', text: 'Na wąskiej szarfie mieści się mniej znaków. Dłuższą sentencję przenieś na bilecik.' },
    { title: 'Margines na końcach', text: 'Nie zaczynaj napisu przy samej krawędzi - część wstążki znika przy mocowaniu do wieńca.' },
];

const FAQ = [
    {
        question: 'Jaki program do drukowania szarf pogrzebowych wybrać?',
        answer: 'Wystarczy program, który pozwala ustawić wymiary szarfy w centymetrach, ułożyć napisy i zapisać plik do druku. Generator szarf w Nekrodruku działa w przeglądarce - bez instalacji - i zapisuje PDF w dokładnym wymiarze szarfy.',
    },
    {
        question: 'Jaka drukarka do szarf pogrzebowych?',
        answer: 'Najczęściej używa się drukarek termotransferowych przystosowanych do druku na wstążkach satynowych, z foliami w różnych kolorach. Wybór zależy od szerokości szarf i liczby zamówień - napisz do nas, pomożemy dobrać sprzęt.',
    },
    {
        question: 'Czy trzeba instalować program na komputerze?',
        answer: 'Nie. Nekrodruk działa w przeglądarce, więc szarfy przygotujesz na dowolnym komputerze w kwiaciarni lub zakładzie. Wystarczy założyć konto.',
    },
    {
        question: 'Jak zrobić szarfę pogrzebową z własnym logo lub symbolem?',
        answer: 'W generatorze szarf dodasz gotowy symbol jednym kliknięciem - krzyż, różę, znicz, gołębia, kłosy lub wieniec - albo wgrasz własny obraz PNG lub JPG, np. logo. Każdy element ustawisz, przeciągając go na podglądzie.',
    },
    {
        question: 'Czy mogę zlecić druk szarfy w drukarni?',
        answer: 'Tak. Pobrany plik PDF ma wymiary szarfy w skali 1:1, więc drukarnia może go wydrukować bez dodatkowego przygotowania.',
    },
];

export default function DrukowanieSzarf() {
    return (
        <GuideLayout
            path='/drukowanie-szarf-pogrzebowych'
            title='Drukowanie szarf pogrzebowych - program i poradnik dla kwiaciarni | Nekrodruk.pl'
            description='Jak zrobić i wydrukować szarfę pogrzebową? Poradnik dla kwiaciarni i zakładów pogrzebowych: krok po kroku, wskazówki druku i program do drukowania szarf w przeglądarce - gotowe napisy, symbole, obramowania i PDF w skali 1:1.'
            keywords='drukowanie szarf pogrzebowych, program do drukowania szarf, druk na szarfie, drukarka do szarf pogrzebowych, jak zrobić szarfę pogrzebową, szarfy do wieńców, szarfy dla kwiaciarni, szarfa z różą, szarfa z krzyżem'
            heading={<>Drukowanie szarf pogrzebowych<em> - poradnik i program dla kwiaciarni</em></>}
            lead='Jak przygotować i wydrukować szarfę do wieńca lub wiązanki - krok po kroku. Do tego program do drukowania szarf, który działa w przeglądarce i zapisuje plik w dokładnym wymiarze szarfy.'
            actions={
                <>
                    <Link to='/register' className='guide_btn guide_btn--light'>
                        Załóż konto
                    </Link>
                    <HashLink smooth to='/drukowanie-szarf-pogrzebowych#generator' className='guide_btn guide_btn--ghost'>
                        Zobacz generator szarf
                    </HashLink>
                </>
            }
            faq={FAQ}
        >
            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Krok po kroku</span>
                    <h2 className='guide_title'>Jak zrobić szarfę pogrzebową?</h2>
                    <ol className='guide_steps guide_steps--wide'>
                        {STEPS.map((step) => (
                            <li key={step.title}>
                                <strong>{step.title}</strong>
                                <span>{step.text}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            <section className='guide_section guide_section--soft' id='generator'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Program do drukowania szarf</span>
                    <h2 className='guide_title'>Generator szarf w Nekrodruku</h2>
                    <p className='guide_lead'>
                        Projekt szarfy przygotujesz w kilka minut, bez programów graficznych: wybierz gotowy napis, dodaj
                        symbol i obramowanie, a podgląd całej szarfy masz cały czas przed oczami. Generator jest dostępny
                        po założeniu konta - w tym samym miejscu, w którym tworzysz nekrologi, klepsydry i tabliczki.
                    </p>
                    <figure className='guide_screenshot'>
                        <img
                            src={generatorPreview}
                            alt='Generator szarf pogrzebowych w Nekrodruku: podgląd szarfy z napisami, krzyżem, różami i zniczem oraz wybór symboli'
                            width='1000'
                            height='560'
                            loading='lazy'
                        />
                        <figcaption>Generator szarf w Nekrodruku - podgląd całej szarfy, gotowe symbole i obramowanie w kolorze złotym</figcaption>
                    </figure>
                    <div className='guide_cards'>
                        {FEATURES.map((feature) => (
                            <article key={feature.title} className='guide_card'>
                                <h3>{feature.title}</h3>
                                <p>{feature.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Dla kogo</span>
                    <h2 className='guide_title'>Dla kwiaciarni, zakładów i drukarni</h2>
                    <div className='guide_cards'>
                        {FOR_WHOM.map((item) => (
                            <article key={item.title} className='guide_card'>
                                <h3>{item.title}</h3>
                                <p>{item.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className='guide_section guide_section--soft'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Wskazówki</span>
                    <h2 className='guide_title'>Druk na szarfie - jak uzyskać czytelny efekt</h2>
                    <ul className='guide_checklist'>
                        {TIPS.map((tip) => (
                            <li key={tip.title}>
                                <strong>{tip.title}</strong>
                                <span>{tip.text}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className='guide_section'>
                <div className='guide_inner'>
                    <div className='guide_callout'>
                        <div>
                            <h2>
                                Prowadzisz kwiaciarnię?<em> Zacznij drukować szarfy szybciej</em>
                            </h2>
                            <p>
                                Załóż konto i przygotuj pierwszą szarfę. Masz pytania o sprzęt lub szablony? Napisz - pomożemy
                                dobrać drukarkę i ustawienia.
                            </p>
                        </div>
                        <div className='guide_actions'>
                            <Link to='/register' className='guide_btn guide_btn--light'>
                                Załóż konto
                            </Link>
                            <HashLink smooth to='/#Contact' className='guide_btn guide_btn--ghost'>
                                Napisz do nas
                            </HashLink>
                        </div>
                    </div>
                </div>
            </section>
        </GuideLayout>
    );
}
